import { useSelector } from "@legendapp/state/react";
import { authStore } from "@website/store/store";

export const getIsLogin = () => Boolean(authStore.accessToken.get());

export const useIsLogin = () => {
  const accessToken = useSelector(authStore.accessToken);
  return Boolean(accessToken);
};
